const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onBackClick: {
      to: "/"
    },
    link: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
